// What a client may see of a project's work (spec 2026-10-27 §A). Every client-facing meeting
// path — Generate packet, line-of-effort bars, tiles — filters through this one rule:
//   - a task is hidden when it is private or its objective is private;
//   - an objective is hidden when it is private, or it has tasks and every one is hidden.
// Objectives with no tasks stay. A missing `private` field means visible.
export function clientVisibleWork(objectives = [], tasks = []) {
  const objs = objectives || [];
  const all = tasks || [];
  const privateObj = new Set(objs.filter((o) => o.private === true).map((o) => o.id));
  const hiddenTask = (t) => t.private === true || privateObj.has(t.objectiveId);
  const visibleTasks = all.filter((t) => !hiddenTask(t));
  const visibleObjectives = objs.filter((o) => {
    if (privateObj.has(o.id)) return false;
    const its = all.filter((t) => t.objectiveId === o.id);
    return its.length === 0 || its.some((t) => !hiddenTask(t));
  });
  return { objectives: visibleObjectives, tasks: visibleTasks };
}
